import { render, staticRenderFns } from "./PostPackageCreateView.vue?vue&type=template&id=2f426aad&scoped=true"
import script from "./PostPackageCreateView.vue?vue&type=script&lang=js"
export * from "./PostPackageCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f426aad",
  null
  
)

export default component.exports